<template>
  <g>
    <rect
      v-if="back"
      class="backRect"
      :x="x + depthOffset.x"
      :y="y - depthOffset.y"
      :width="width"
      :height="height"
    />
    <polygon
      v-if="left"
      class="leftPolygon"
      :points="leftPolygon"
    />
    <polygon
      v-if="right"
      class="rightPolygon"
      :points="rightPolygon"
    />
  </g>
</template>

<script>
  export default {
    name: 'Shelf',
    props: {
      x: Number,
      y: Number,
      width: Number,
      height: {
        type: Number,
        default: 5,
      },
      depthOffset: Object,
      left: {
        type: Boolean,
        default: false,
      },
      right: {
        type: Boolean,
        default: false,
      },
      back: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      leftPolygon() {
        return `${this.x},${this.y}
          ${this.x + this.depthOffset.x},${this.y - this.depthOffset.y}
          ${this.x + this.depthOffset.x},${this.y - this.depthOffset.y + this.height}
          ${this.x},${this.y + this.height}`;
      },
      rightPolygon() {
        return `${this.x + this.width},${this.y}
          ${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y}
          ${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y + this.height}
          ${this.x + this.width},${this.y + this.height}`;
      },
    },
  };
</script>

<style scoped>
  .leftPolygon {
    fill: #d0d0d0;
  }
  .rightPolygon {
    fill: #d0d0d0;
  }
  .backRect {
    fill: #bbbbbc;
  }
</style>
